<script>
/* eslint-disable no-empty */
/* eslint-disable no-undef */
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
/* eslint-disable vue/no-unused-components */
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import Swal from "sweetalert2";
import moment from "moment";

import DatePicker from "vue2-datepicker";
import Switches from "vue-switches";
import Multiselect from "vue-multiselect";
import HotelDatePicker from "vue-hotel-datepicker";
import NumberInputSpinner from "vue-number-input-spinner";
import { icons } from "../data-fontawesome";
import { urlMethods } from "@/state/helpers";

export default {
  page: {
    title: "Đơn hàng",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    HotelDatePicker,
    DatePicker,
    Switches,
    Multiselect,
    NumberInputSpinner,
  },
  data() {
    return {
      title: "Đơn hàng",
      icons: icons,
      loadingArr: [],
      breadcrumbData: [
        { text: "Trang chủ", to: { name: "default" } },
        { text: "Đơn hàng", to: { name: "order" } },
        { text: "Chi tiết", active: true },
      ],
      order: {
        id: 0,
      },
      logs: [],
      customer: {
        id: 0,
      },
    };
  },
  computed: {
    currentUser() {
      let user = localStorage.getItem("currentUser") || false;
      return user ? JSON.parse(user) : false;
    },
    order_name() {
      if (!this.order || !this.order.name) return "";
      return this.order.name;
    },
    order_name_heder() {
      if (!this.order || !this.order.name) return "THÔNG TIN ĐƠN HÀNG";
      return this.order.name;
    },
    amount_product_total() {
      if (
        !this.order ||
        typeof this.order.products == "undefined" ||
        !this.order.products
      )
        return 0;
      var total = this.order.products.reduce(function(tot, record) {
        return tot + record.amount;
      }, 0);
      return total.toLocaleString();
    },
  },
  async created() {
    this.getOrder();
  },
  methods: {
    ...urlMethods,
    removeLoading(_id = "") {
      this.loadingArr = this.loadingArr.filter(function(item) {
        return item != _id;
      });
    },
    isLoading(name = "") {
      return this.loadingArr.includes(name);
    },
    async syncOrder() {
      let that = this;
      let id = this.order.id;
      Swal.fire({
        title: "Bạn có chắc chắn?",
        showCancelButton: true,
        confirmButtonText: "Đồng bộ ngay",
        cancelButtonText: "Không. Bỏ qua",
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.loadingArr.push("sync");
          setTimeout(async () => {
            try {
              let res = await that.postUrl({
                url: "sync-order",
                data: { id: id, posID: that.currentUser.pos_id },
              });
              if (typeof res.error != "undefined" && res.error) {
                throw res.message;
              }
              that.removeLoading("sync");
              that.getOrder();
            } catch (error) {
              that.removeLoading("sync");
              Swal.fire({ icon: "error", title: "Lỗi...", text: error });
              that.getOrder();
            }
          }, 100);
        } else if (result.isDenied) {
          this.removeLoading("sync");
        }
      });
    },
    async updateSession() {
      let that = this;
      let id = this.order.id;
      Swal.fire({
        title: "Thao tác không thể khôi phục. Bạn có chắc chắn?",
        showCancelButton: true,
        confirmButtonText: "Có. Tiếp tục",
        cancelButtonText: "Không. Bỏ qua",
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.loadingArr.push("session");
          setTimeout(async () => {
            try {
              let res = await that.postUrl({
                url: "update-session",
                data: { id: id, posID: that.currentUser.pos_id },
              });
              if (typeof res.error != "undefined" && res.error) {
                throw res.message;
              }
              that.removeLoading("session");
              that.getOrder();
            } catch (error) {
              that.removeLoading("session");
              Swal.fire({ icon: "error", title: "Lỗi...", text: error });
            }
          }, 100);
        } else if (result.isDenied) {
          this.removeLoading("session");
        }
      });
    },
    async cancelOrder() {
      let that = this;
      let id = this.order.id;
      Swal.fire({
        title: "Thao tác huỷ đơn không thể khôi phục. Bạn có chắc chắn?",
        showCancelButton: true,
        confirmButtonText: "Huỷ đơn",
        cancelButtonText: "Không. Bỏ qua",
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.loadingArr.push("cancel");
          setTimeout(async () => {
            try {
              let res = await that.postUrl({
                url: "cancel-order",
                data: { id: id, posID: that.currentUser.pos_id },
              });
              if (typeof res.error != "undefined" && res.error) {
                throw res.message;
              }
              that.removeLoading("cancel");
            } catch (error) {
              that.removeLoading("cancel");
              Swal.fire({ icon: "error", title: "Lỗi...", text: error });
            }
            that.getOrder();
          }, 100);
        } else if (result.isDenied) {
          this.removeLoading("cancel");
        }
      });
    },
    formatMoney(input) {
      if (
        typeof input == "undefined" ||
        input == null ||
        !input ||
        isNaN(input)
      )
        return 0;
      return input.toLocaleString();
    },
    async getOrder() {
      this.order.id = this.$route.params.id;
      try {
        let res = await this.getUrl("order/" + this.order.id);
        if (
          typeof res.data == "undefined" ||
          !res.data ||
          res.data == null ||
          typeof res.data.id == "undefined"
        ) {
          throw "Không thể lấy thông tin đơn hàng";
        }
        this.order = res.data;
        this.order.payments = JSON.parse(this.order.account_statements);

        let res_log = await this.getUrl("order-logs/" + this.order.id);
        if (
          !(
            typeof res_log.data == "undefined" ||
            !res_log.data ||
            res_log.data == null ||
            typeof res_log.data[0] == "undefined"
          )
        ) {
          this.logs = res_log.data;
        }

        let resCustomer = await this.getUrl(
          "customer/" + this.order.partner_id
        );
        console.log(resCustomer);
        if (typeof resCustomer.data !== "undefined") {
          this.customer = resCustomer.data;
        }
      } catch (error) {
        Swal.fire({ icon: "error", title: "Lỗi...", text: error });
      }
    },
    discount_text(discount) {
      if (!discount || discount <= 0) return "0%";
      return discount + "%";
    },
  },
  mounted() {},
};
</script>

<template>
  <Layout>
    <div>
      <div class="page-header mb-2">
        <div class="page-title">
          <h4 class="mb-0 font-size-18" v-html="order_name"></h4>
          <span
            style="margin-left: 5px; padding-top: 5px !important;"
            :class="'badge font-size-12 bg-' + order.status_class"
            >{{ order.status_name }}</span
          >
        </div>
        <b-breadcrumb :items="breadcrumbData" class="m-0 p-0"></b-breadcrumb>
      </div>
      <div class="row">
        <div class="col-md-6  mb-0">
          <div class="card p-0  mb-0">
            <div class="card-body p-0  mb-0">
              <div class="table-responsive">
                <table
                  class="table table-striped mb-0"
                  style="background: white;"
                >
                  <tbody>
                    <tr>
                      <td width="100px">Khách hàng</td>
                      <th scope="row">
                        {{ order.customer_name }} -
                        {{ order.customer_phone }}
                        (
                        {{
                          customer.gender === 1 || customer.gender === 2
                            ? "Nữ"
                            : "Nam"
                        }}
                        -
                        {{ customer.birthdate }}
                        )
                      </th>
                    </tr>
                    <tr>
                      <td>NVBH</td>
                      <th scope="row">{{ order.sale_man_name }}</th>
                    </tr>
                    <tr>
                      <td>Thu ngân</td>
                      <th scope="row">{{ order.user_name }}</th>
                    </tr>
                    <tr>
                      <td>Địa điểm</td>
                      <th scope="row">{{ order.pos_name }}</th>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6  mb-0">
          <div class="card p-0  mb-0">
            <div class="card-body p-0  mb-0">
              <div class="table-responsive">
                <table
                  class="table table-striped mb-0"
                  style="background: white;"
                >
                  <tbody>
                    <tr>
                      <td width="100px">Phiên</td>
                      <th scope="row">
                        <router-link :to="'/session/' + order.session_id">{{
                          order.session_name
                        }}</router-link>
                      </th>
                    </tr>
                    <tr>
                      <td>Ngày đặt hàng</td>
                      <th scope="row">{{ order.created_at_format }}</th>
                    </tr>
                    <tr v-if="order.note != ''">
                      <td>Ghi chú</td>
                      <th scope="row" v-html="order.note"></th>
                    </tr>
                    <tr v-if="order.status == 'error'">
                      <td>Lỗi đồng bộ</td>
                      <th scope="row">{{ order.error_sync }}</th>
                    </tr>
                    <tr>
                      <td>Xử lý:</td>
                      <td>
                        <a :href="'/print/' + order.id" target="_blank"
                          ><b-button size="sm" variant="success"
                            ><i class="bx bx-printer"></i> In hóa đơn</b-button
                          ></a
                        >
                        <b-button
                          size="sm"
                          style="margin-left: 5px;"
                          variant="primary"
                          @click="syncOrder()"
                          v-if="
                            order.status == 'new' || order.status == 'error'
                          "
                          ><i
                            v-if="!isLoading('sync')"
                            class="bx bx-transfer-alt align-middle font-size-14"
                          ></i>
                          <i
                            v-if="isLoading('sync')"
                            class="fas fa-spinner fa-spin font-size-14"
                          ></i>
                          Đồng bộ ngay</b-button
                        >
                        <b-button
                          size="sm"
                          style="margin-left: 5px;"
                          variant="warning"
                          @click="updateSession()"
                          v-if="order.status == 'error'"
                          ><i
                            v-if="!isLoading('session')"
                            class="bx bx-rotate-right align-middle font-size-14"
                          ></i
                          ><i
                            v-if="isLoading('session')"
                            class="fas fa-spinner fa-spin font-size-14"
                          ></i>
                          Cập nhật phiên mới</b-button
                        >
                        <b-button
                          size="sm"
                          style="margin-left: 5px;"
                          variant="danger"
                          @click="cancelOrder()"
                          v-if="
                            order.status == 'new' || order.status == 'error'
                          "
                          ><i
                            v-if="!isLoading('cancel')"
                            class="bx bx-x align-middle font-size-14"
                          ></i
                          ><i
                            v-if="isLoading('cancel')"
                            class="fas fa-spinner fa-spin font-size-14"
                          ></i>
                          Huỷ đơn</b-button
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card" style="margin-top: 15px;">
        <b-tabs
          content-class="p-3"
          nav-wrapper-class="nav-item"
          class="pt-2"
          nav-class="justify-content-center nav-tabs-custom"
        >
          <b-tab title="Sản phẩm" active>
            <div
              class="text-center"
              v-if="
                !(
                  typeof order.products != 'undefined' &&
                  order.products &&
                  order.products != null &&
                  order.products.length > 0
                )
              "
            >
              Không có sản phẩm
            </div>
            <div class="table-responsive" v-else>
              <table class="table table-bordered mb-0">
                <thead class="table-light">
                  <tr>
                    <th scope="row">Sản phẩm</th>
                    <th>Serial</th>
                    <!-- <th>Số lượng</th> -->
                    <th>Đơn giá</th>
                    <th>Chiết khấu</th>
                    <th>Thành tiền</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in order.products" :key="item.id">
                    <td>{{ item.product_name }}</td>
                    <td>{{ item.serial }}</td>
                    <!-- <td>{{ item.serial.split(",").length }}</td> -->
                    <td>{{ formatMoney(item.price_unit) }} <sup>₫</sup></td>
                    <td>{{ discount_text(item.discount) }}</td>
                    <td>{{ formatMoney(item.amount) }} <sup>₫</sup></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="pull-right" style="max-width: 300px;">
              <table class="table mb-0 mt-2">
                <tbody>
                  <tr>
                    <td>Tổng tiền hàng:</td>
                    <th class="text-right">
                      {{ amount_product_total }} <sup>₫</sup>
                    </th>
                  </tr>
                  <tr v-if="order.voucher_discount > 0">
                    <td>
                      <span
                        :title="order.voucher_name"
                        :alt="order.voucher_name"
                        >Giảm voucher</span
                      >:
                    </td>
                    <th class="text-right">
                      - {{ formatMoney(order.voucher_discount) }} <sup>₫</sup>
                    </th>
                  </tr>
                  <tr v-if="order.member_discount > 0">
                    <td>
                      <span
                        :title="order.member_discount"
                        :alt="order.member_discount"
                        >Giảm thành viên</span
                      >:
                    </td>
                    <th class="text-right">
                      - {{ formatMoney(order.member_discount) }} <sup>₫</sup>
                    </th>
                  </tr>
                  <tr v-if="order.other_discount > 0">
                    <td>
                      <span
                        :title="order.other_discount"
                        :alt="order.other_discount"
                        >Giảm khác</span
                      >:
                    </td>
                    <th class="text-right">
                      - {{ formatMoney(order.other_discount) }} <sup>₫</sup>
                    </th>
                  </tr>
                  <tr v-if="order.feeship > 0">
                    <td>
                      <span :title="order.feeship" :alt="order.feeship"
                        >Phí vận chuyển</span
                      >:
                    </td>
                    <th class="text-right">
                      {{ formatMoney(order.feeship) }} <sup>₫</sup>
                    </th>
                  </tr>
                  <tr style="font-size: 1.3em; font-weight: bold;">
                    <td>THÀNH TIỀN:</td>
                    <th>{{ formatMoney(order.amount_total) }} <sup>₫</sup></th>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-tab>
          <b-tab title="Thanh toán">
            <div
              class="text-center"
              v-if="
                !(
                  typeof order.payments != 'undefined' &&
                  order.payments &&
                  order.payments != null &&
                  order.payments.length > 0
                )
              "
            >
              Không có thanh toán
            </div>
            <div class="table-responsive" v-else>
              <table class="table table-bordered mb-0">
                <thead class="table-light">
                  <tr>
                    <th scope="row">Hình thức thanh toán</th>
                    <th>Số tiền</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in order.payments" :key="item.id">
                    <td>{{ item.journal_name }}</td>
                    <td>{{ formatMoney(item.amount) }} <sup>₫</sup></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-tab>
          <b-tab title="Lịch sử">
            <div class="table-responsive">
              <table class="table table-bordered mb-0">
                <thead class="table-light">
                  <tr>
                    <th scope="row">Thời gian</th>
                    <th>Hành động</th>
                    <th>Nhân viên</th>
                    <th>Email</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in logs" :key="item.id">
                    <td>{{ item.created_at }}</td>
                    <td>{{ item.content }}</td>
                    <td>{{ item.username }}</td>
                    <td>{{ item.email }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </Layout>
</template>
